module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_7016.e76d1b08.png";